import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  MODE_CPU,
  MODE_MULTIPLAYER,
  setSelectedGameMode,
  startFreshCpuGame,
} from "../../game/gameModeStorage";
import "./modes.css";

const LOGO_SRC = `${process.env.PUBLIC_URL}/img/game-logo.png`;
const COMPUTER_SRC = `${process.env.PUBLIC_URL}/img/computer.png`;
const MULTIPLAYER_SRC = `${process.env.PUBLIC_URL}/img/multiplayer.png`;

function readUserId() {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    const data = JSON.parse(raw) || {};
    return String(data?.userId ?? data?.userid ?? data?.id ?? "").trim();
  } catch {
    return "";
  }
}

function readUserName() {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    const data = JSON.parse(raw) || {};
    const name = String(data?.name ?? data?.userName ?? "").trim();
    if (name) return name;
    const email = String(data?.email ?? "").trim();
    if (email) return email.split("@")[0];
    return "You";
  } catch {
    return "You";
  }
}

function Modes() {
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add("modes-static-bg");
    document.body.classList.add("modes-static-bg");
    return () => {
      document.documentElement.classList.remove("modes-static-bg");
      document.body.classList.remove("modes-static-bg");
    };
  }, []);

  const pickCpu = () => {
    setSelectedGameMode(MODE_CPU);
    const userId = readUserId();
    const name = readUserName();
    startFreshCpuGame(userId, name);
    navigate("/game", { replace: true });
  };

  const pickMultiplayer = () => {
    setSelectedGameMode(MODE_MULTIPLAYER);
    navigate("/lobby", { replace: true });
  };

  return (
    <div className="modes-page">
      <img
        className="modes-logo"
        src={LOGO_SRC}
        alt="Connect 4 Showdown"
      />
      <div className="modes-row">
        <button
          type="button"
          className="modes-choice-btn"
          onClick={pickCpu}
          aria-label="Play vs computer"
        >
          <img
            className="modes-choice"
            src={COMPUTER_SRC}
            alt=""
          />
        </button>
        <button
          type="button"
          className="modes-choice-btn"
          onClick={pickMultiplayer}
          aria-label="Play multiplayer"
        >
          <img
            className="modes-choice"
            src={MULTIPLAYER_SRC}
            alt=""
          />
        </button>
      </div>
    </div>
  );
}

export default Modes;
